import type { ComponentEntry } from '../../core/common-types'

const entry: ComponentEntry = {
	componentType: 'TPAWorker',
	loadComponent: () => import('./TPAWorker.js' /* webpackChunkName: "TPAWorker" */),
}

export default entry
